import { combineReducers } from '@reduxjs/toolkit';

import {
  emailSlice, setBcc, setCc, setContent, setSubject, setTemplateName,
  setTemplateType, setTo,
} from './email';

export const EMAIL_REDUCER_PATH = 'email';

export const emailReducer = combineReducers({
  email: emailSlice.reducer,
});

export const emailActions = {
  setTemplateName,
  setContent,
  setSubject,
  setCc,
  setBcc,
  setTo,
  setTemplateType,
};

export interface RootState {
  email: ReturnType<typeof emailReducer>;
}
